require('jquery');
require('bootstrap');
require('air-datepicker');
require('../../node_modules/air-datepicker/dist/js/i18n/datepicker.fr.js');
global.$ = global.jQuery = $;
global.moment = require('moment');

// TODO seem useless
//global.Dropzone = require('dropzone');
import './polyfill'
import './collabPack'
import './formTrigger'
import './datalist'
import './fieldCopyValue'
import './render_view_vehicle'
import './equipment_list'
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch'
import {openForm} from '../../public/bundles/w3comhulk/utils.js';

global.openForm = openForm;

import {handleDatePicker} from './datepicker'
global.handleDatePicker = handleDatePicker;

import {
    init as initAdjudicationForm,
    openBP,
    reloadBusinessPartner,
    adjustByCountry
} from './edit_adjudication_vehicle';

global.initAdjudicationForm = initAdjudicationForm;
global.openBP = openBP;
global.reloadBusinessPartner = reloadBusinessPartner;
global.adjustByCountry = adjustByCountry;

import {
    init as initVehicleFolder,
    vehicleFolderOpenPj,
    adjustPercent,
    inputHelper,
    checkImmat,
    initArgusTable,
    assessmentCopy,
    createModelButton, checkMileage,
} from './edit_vehicle';
global.initVehicleFolder = initVehicleFolder;
global.vehicleFolderOpenPj = vehicleFolderOpenPj;
global.adjustPercent = adjustPercent;
global.inputHelper = inputHelper;
global.checkImmat = checkImmat;
global.checkMileage = checkMileage;
global.initArgusTable = initArgusTable;
global.assessmentCopy = assessmentCopy;
global.createModelButton = createModelButton;

import {init as initAdjudicationDissociate} from './edit_adjudication_dissociate';
global.initAdjudicationDissociate = initAdjudicationDissociate;

// Don't disable button, chrome 47
global.disableSubmitButton = function (obj) {
    obj.classList.add('d-none');
};

import {disableSubmitButton as disableSubmitButtonAjax} from "../../public/bundles/w3comhulk/ajax";
global.disableSubmitButtonAjax = disableSubmitButtonAjax;

import {
    addBusinessPartner as sparkAddBusinessPartner,
    removeDemand as sparkRemoveDemand,
    updateBusinessPartner as sparkUpdateBusinessPartner
} from "./spark";
global.sparkAddBusinessPartner = sparkAddBusinessPartner;
global.sparkRemoveDemand = sparkRemoveDemand;
global.sparkUpdateBusinessPartner = sparkUpdateBusinessPartner;

import {init as initVehicleImport} from "./import_vehicle";
global.initVehicleImport = initVehicleImport;

import {init as initFormSale} from './sale';

global.initFormSale = initFormSale;

import "./folder";

import {vehicleSaleAssignment} from "./display_liste_vehicule_vente";
global.vehicleSaleAssignment = vehicleSaleAssignment;

// Active popover
$(function () {
    $('[data-toggle="popover"]').popover()
});


// WEBPACK FOOTER //
// ./assets/js/app.js